/**
 * localStorage 缓存工具
 * 提供带过期时间的本地存储封装
 */

const HISTORY_CONVERSATION_KEY = "historyConversationId";
const EXPIRE_DAYS = 60;

/**
 * 保存历史会话 ID，附带当前时间戳
 * @param {string} id - 会话 ID
 */
export function setHistoryConversationId(id) {
  const data = { value: id, timestamp: Date.now() };
  localStorage.setItem(HISTORY_CONVERSATION_KEY, JSON.stringify(data));
}

/**
 * 读取历史会话 ID，自动判断是否过期
 * 过期则清除缓存并返回空字符串
 * @returns {string} 会话 ID，过期或不存在时返回空字符串
 */
export function getHistoryConversationId() {
  const raw = localStorage.getItem(HISTORY_CONVERSATION_KEY);
  if (!raw) return "";

  try {
    const { value, timestamp } = JSON.parse(raw);
    const elapsed = Date.now() - timestamp;
    const maxMs = EXPIRE_DAYS * 24 * 60 * 60 * 1000;

    if (elapsed >= maxMs) {
      localStorage.removeItem(HISTORY_CONVERSATION_KEY);
      return "";
    }
    return value || "";
  } catch {
    // JSON 解析失败，判断是否为旧版本纯字符串格式
    // 旧格式: "abc123" → 迁移为新格式 { value: "abc123", timestamp: Date.now() }
    if (raw.trim().charAt(0) !== "{") {
      setHistoryConversationId(raw);
      return raw;
    }
    // 确实是脏数据，清除缓存
    localStorage.removeItem(HISTORY_CONVERSATION_KEY);
    return "";
  }
}

/**
 * 主动清除历史会话 ID 缓存
 */
export function clearHistoryConversationId() {
  localStorage.removeItem(HISTORY_CONVERSATION_KEY);
}
